exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader?outputStyle=expanded!./source/136-flareon/Flareon.scss
 ** module id = 455
 ** module chunks = 0
 **/